import { inject, Injectable } from '@angular/core';
import { AccountService } from '@frontendlib/common/services/account.service';
import { SpacesService } from '@modules/settings/services/spaces.service';
import { type Space } from '@modules/settings/types/space';
import { EMPTY, expand, first, map, type Observable, of, switchMap, take } from 'rxjs';

export interface NoteOwningWorkspace {
  readonly spaceTenantId: string;
  readonly spaceTitle: string;
}

@Injectable()
export class NoteOwningWorkspaceService {
  private readonly accounts = inject(AccountService);
  private readonly spaces = inject(SpacesService);

  public resolve(tenantId: string): Observable<NoteOwningWorkspace | null> {
    return this.accounts.getAccount().pipe(
      take(1),
      switchMap((account) =>
        tenantId === account.id
          ? of(null)
          : this.spaces.listWithInvites({ archived: false, limit: 100 }, { account }).pipe(
              expand((page, index) =>
                page.items.length && (index + 1) * 100 < page.count
                  ? this.spaces.listWithInvites({ archived: false, limit: 100, offset: (index + 1) * 100 }, { account })
                  : EMPTY,
              ),
              map((page) =>
                page.items.find((space: Space) => space.id === tenantId && space.currentUserStatus === 'accepted'),
              ),
              first((space) => !!space, undefined),
              map((space) => (space ? { spaceTenantId: space.id, spaceTitle: space.title } : null)),
            ),
      ),
    );
  }
}
